"use strict";
'use es6'; // Prevent unwanted focus styles

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIRadioInput;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

require("../listeners/focusStylesListener");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _useUniqueId = _interopRequireDefault(require("react-utils/hooks/useUniqueId"));

var _memoize = _interopRequireDefault(require("react-utils/memoize"));

var _FieldsetContext = require("../context/FieldsetContext");

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _CheckboxConstants = require("./CheckboxConstants");

var _ToggleInputWrapper = _interopRequireDefault(require("./internal/ToggleInputWrapper"));

var renderIndicator = (0, _memoize.default)(function (color) {
  return _react.default.createElement("span", {
    className: "private-checkbox__indicator private-radio__indicator",
    "data-indicator": true,
    style: {
      color: color
    }
  }, _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22"
  }, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, _react.default.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "10",
    className: "private-radio__circle",
    stroke: "currentColor",
    strokeWidth: "1.5"
  }), _react.default.createElement("circle", {
    className: "private-radio__dot",
    id: "a",
    cx: "10",
    cy: "10",
    r: "5"
  }))));
});

function UIRadioInput(props) {
  var ariaLabel = props['aria-label'],
      ariaLabelledBy = props['aria-labelledby'],
      checked = props.checked,
      children = props.children,
      className = props.className,
      color = props.color,
      defaultChecked = props.defaultChecked,
      description = props.description,
      disabled = props.disabled,
      id = props.id,
      name = props.name,
      _onChange = props.onChange,
      readOnly = props.readOnly,
      size = props.size,
      value = props.value,
      rest = (0, _objectWithoutProperties2.default)(props, ["aria-label", "aria-labelledby", "checked", "children", "className", "color", "defaultChecked", "description", "disabled", "id", "name", "onChange", "readOnly", "size", "value"]);

  var _useContext = (0, _react.useContext)(_FieldsetContext.FieldsetContext),
      fieldSize = _useContext.size,
      fieldDisabled = _useContext.disabled;

  var descriptionId = (0, _useUniqueId.default)('radio-');
  var childWrapperId = (0, _useUniqueId.default)('radio-content-');
  var computedSize = size || fieldSize;
  var computedDisabled = disabled || fieldDisabled;
  var ariaLabelledByIds = (0, _classnames.default)(ariaLabelledBy, children && childWrapperId);

  if (process.env.NODE_ENV !== 'production') {
    if (!name) {
      _devLogger.default.warn({
        message: 'UIRadioInput: `name` must be specified. Try wrapping with `UIToggleGroup`.',
        key: 'UIRadioInput: name'
      });
    }

    if (children == null && !ariaLabel && !ariaLabelledBy) {
      _devLogger.default.warn({
        message: "UICheckbox: `aria-label` or `aria-labelledby` is required if you don't define `children`.",
        key: 'UICheckbox: no label'
      });
    }

    if (ariaLabel && (children || ariaLabelledBy)) {
      _devLogger.default.warn({
        message: 'UIRadioInput: `aria-label` should not be used with `children` or `aria-labelledby`.',
        key: 'UIRadioInput: aria-label hides children',
        url: 'https://git.hubteam.com/HubSpot/UIComponents/pull/8473/files#r1011220'
      });
    }
  }

  return _react.default.createElement(_ToggleInputWrapper.default, Object.assign({}, rest, {
    checked: checked,
    childWrapperId: childWrapperId,
    className: (0, _classnames.default)(className, 'private-radio', !children ? 'private-checkbox--flush' : 'private-checkbox'),
    description: description,
    descriptionId: descriptionId,
    disabled: computedDisabled,
    input: _react.default.createElement("input", {
      "aria-describedby": description ? descriptionId : null,
      "aria-label": ariaLabel,
      "aria-labelledby": ariaLabelledByIds,
      checked: checked,
      className: "sr-only private-checkbox__input",
      defaultChecked: defaultChecked,
      disabled: computedDisabled,
      id: id,
      name: name,
      onChange: function onChange(evt) {
        if (disabled || readOnly) {
          evt.preventDefault();
          return;
        }

        if (_onChange) _onChange(evt);
      },
      readOnly: readOnly,
      type: "radio",
      value: value
    }),
    indicator: renderIndicator(color),
    onChange: _onChange,
    readOnly: readOnly,
    size: computedSize
  }), children);
}

UIRadioInput.propTypes = {
  alignment: _propTypes.default.oneOf(Object.keys(_CheckboxConstants.ALIGNMENT_CLASSES)),
  'aria-label': _propTypes.default.string,
  'aria-labelledby': _propTypes.default.string,
  checked: _propTypes.default.bool,
  children: _propTypes.default.node,
  color: _propTypes.default.string,
  defaultChecked: _propTypes.default.bool,
  description: _propTypes.default.node,
  descriptionLayout: _propTypes.default.oneOf(['horizontal', 'vertical']),
  disabled: _propTypes.default.bool,
  inline: _propTypes.default.bool,
  labelClassName: _propTypes.default.string,
  name: _propTypes.default.string,
  onChange: _propTypes.default.func,
  readOnly: _propTypes.default.bool,
  size: _propTypes.default.oneOfType([(0, _tshirtSize.propTypeForSizes)(['sm']), _propTypes.default.oneOf(['default'])]),
  value: _propTypes.default.any
};
UIRadioInput.defaultProps = {
  alignment: 'start',
  descriptionLayout: 'vertical'
};
UIRadioInput.displayName = 'UIRadioInput';
module.exports = exports.default;